import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
	},
	stickerMedia: {
		objectFit: "contain",
		width: 160,
		height: 160,
		background: "transparent",
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
}));

const ModalImageCors = ({ imageUrl, isSticker = false }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");

	useEffect(() => {
		if (!imageUrl) return undefined;
		setFetching(true);
		setBlobUrl("");
		let cancelled = false;
		let createdBlobUrl = null;

		const fetchImage = async () => {
			try {
				// Absolute URLs (Hostinger / public backend) — fetch as blob so broken
				// CDN/HTML responses don't leave an empty grey box.
				if (/^https?:\/\//i.test(imageUrl)) {
					const res = await fetch(imageUrl, { mode: "cors" });
					if (!res.ok) throw new Error(`HTTP ${res.status}`);
					const contentType = (res.headers.get("content-type") || "").toLowerCase();
					if (contentType.includes("text/html")) {
						throw new Error("media url returned html");
					}
					const data = await res.blob();
					if (cancelled) return;
					const nextUrl = window.URL.createObjectURL(data);
					createdBlobUrl = nextUrl;
					setBlobUrl(nextUrl);
					return;
				}

				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				if (cancelled) return;
				const nextUrl = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				createdBlobUrl = nextUrl;
				if (cancelled) {
					window.URL.revokeObjectURL(nextUrl);
					return;
				}
				setBlobUrl(nextUrl);
			} catch {
				if (!cancelled) setBlobUrl(imageUrl);
			} finally {
				if (!cancelled) setFetching(false);
			}
		};
		fetchImage();
		return () => {
			cancelled = true;
			if (createdBlobUrl) {
				window.URL.revokeObjectURL(createdBlobUrl);
			}
		};
	}, [imageUrl]);

	return (
		<ModalImage
			className={isSticker ? classes.stickerMedia : classes.messageMedia}
			smallSrcSet={fetching ? imageUrl : blobUrl}
			medium={fetching ? imageUrl : blobUrl}
			large={fetching ? imageUrl : blobUrl}
			alt="image"
		/>
	);
};

export default ModalImageCors;
